import { Experiment, getAB } from '@unitedtraders/utcom-cookie';
import { getUtClientId } from './cookie';

const Default: Experiment = {
  A: 50,
  B: 50,
};

export type ExperimentNames = 'Dummy' | 'KycNotify' | 'LoginWith2FARecomendation';

export const experiments: Record<ExperimentNames, Experiment> = {
  Dummy: Default,
  KycNotify: {
    A: 90,
    B: 10,
  },
  LoginWith2FARecomendation: {
    A: 90,
    B: 10,
  },
};

export const getAllExperiments = () => getAB(getUtClientId(), experiments);

export const getExperiment = (name: ExperimentNames) => getAllExperiments()[name] as 'A' | 'B';

export const getIsInTestGroup = (name: ExperimentNames) =>
  (getAllExperiments()[name] as 'A' | 'B') === 'B';
